/*
 * Copyright (c) 2023-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';

function Overlay({
                     style,
                     className,
                     overlay,
                     topLeft,
                     topCenter,
                     topRight,
                     rightCenter,
                     rightBottom,
                     bottomCenter,
                     bottomRight,
                     leftCenter,
                     bottomLeft,
                     onClick,
                     children
                 }) {
    return (
        <div className={`w-full h-full relative  max-h-full min-h-full  ${className ?? ""}`}
             onClick={onClick}
             style={style}>

            <div className={" h-full w-full pointer-events-auto "}>
                {children}
            </div>


            {/*Top Left just overlay*/}
            {overlay && (<div
                className="absolute top-0 left-0 w-full h-full">
                {overlay}
            </div>)}
            {topLeft && (<div
                className="absolute top-0 left-0">
                {topLeft}
            </div>)}
            {/*Top Center*/}
            {topCenter && (<div
                    className="absolute top-0 left-1/2 -translate-x-1/2">
                    {topCenter}
                </div>
            )}
            {/*Top Right*/}
            {topRight && (<div
                className="absolute top-0 right-0">
                {topRight}
            </div>)}
            {/*Right Center*/}
            {rightCenter && (<div
                className="absolute top-1/2 right-0 -translate-y-1/2">
                {rightCenter}
            </div>)}

            {/*Right bottom*/}
            {rightBottom && (<div
                className="absolute bottom-0 right-0">
                {rightBottom}
            </div>)}

            {/*Bottom Center*/}
            {bottomCenter && (<div
                className="absolute bottom-0 left-1/2 -translate-x-1/2">
                {bottomCenter}
            </div>)}

            {/*Bottom Right*/}
            {bottomRight && (<div
                className="absolute bottom-0 right-0">
                {bottomRight}
            </div>)}

            {/*Bottom Left*/}
            {bottomLeft && (<div
                className="absolute  bottom-0 left-0">
                {bottomLeft}
            </div>)}
            {/*Left Center*/}
            {leftCenter && (<div
                className="absolute  left-0 top-1/2  -translate-y-1/2">
                {leftCenter}
            </div>)}

        </div>
    );
}

export default Overlay;